import { UserRecord } from "./types";

export const userName = (record: UserRecord) => {
	return `${record.first_name} ${record.last_name}`;
};
